import script from "./BlogListView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogListView.vue?vue&type=script&setup=true&lang=js"

import "./BlogListView.vue?vue&type=style&index=0&id=27dd35d6&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dd35d6"]])

export default __exports__